import React from 'react';
import Header from '../components/Header/Header';
import SlottedOrdersLayout from '../layouts/SlottedOrdersLayout';

const SlottedPage = () => {
  return (
    <>
      <Header />
      <SlottedOrdersLayout />
    </>
  );
};

export default SlottedPage;
